import { EthersUtils } from "./utils-index";

export class LSTVaultHelper {
  etherUtils: EthersUtils;
  config: any;

  constructor(config: any, metamask?: any) {
    if (metamask) {
      this.etherUtils = new EthersUtils(metamask);
    } else {
      this.etherUtils = new EthersUtils(config.rpc, {
        privateKey: config.privateKey,
      });
    }
    this.config = config;
  }
  async getUserVaultStatus(address: string) {
    const vault = await this.etherUtils.getContract(
      this.config.contracts.deploy.Vault,
      this.config.abis.IVault
    );

    const link = await this.etherUtils.getContract(
      this.config.CCIP.LINK,
      this.config.abis.IERC20
    );
    const wASTR = await this.etherUtils.getContract(
      this.config.contracts.WASTR,
      this.config.abis.IERC20
    );
    const wstASTR = await this.etherUtils.getContract(
      this.config.contracts.WstASTR,
      this.config.abis.IERC20
    );
    const ASTR = await this.etherUtils.getBalance(address);
    const WASTR = await wASTR.balanceOf(address);
    const WstASTR = await wstASTR.balanceOf(address);
    const assetsOfstASTR = await vault.convertToAssets(WstASTR);
    const linkBalance = await link.balanceOf(address);
    return {
      ASTR,
      WASTR,
      WstASTR,
      assetsOfstASTR,
      linkBalance,
    };
  }
  async getTimeByBlockNumber(blockNumber: number) {
    const blockTimestamp = await this.etherUtils.getBlockTimestamp(blockNumber);
    return blockTimestamp;
  }
  async getUserUnstakeStatus(address: string, nonce: number) {
    const vault = await this.etherUtils.getContract(
      this.config.contracts.deploy.Vault,
      this.config.abis.IVault
    );
    const pendingUnstake = await vault.pendingUnstake(address, nonce);
    const pendingUnstakeAt = await vault.pendingUnstakeAt(address, nonce);
    const pendingUnstakeChain = await vault.pendingUnstakeChain(address, nonce);
    return {
      pendingUnstake,
      pendingUnstakeAt,
      pendingUnstakeChain,
    };
  }
  async getUserUnstakeFromNonce(address: string, fromNonce: number) {
    const vault = await this.etherUtils.getContract(
      this.config.contracts.deploy.Vault,
      this.config.abis.IVault
    );
    const totalNonce = await vault.nonces(address);
    console.log(totalNonce);
    const results: any[] = [];

    for (let i = fromNonce; i < totalNonce; i++) {
      // 获取每个nonce的详细状态
      const unstakeStatus = await this.getUserUnstakeStatus(address, i);
      results.push({
        nonce: i,
        ...unstakeStatus,
      });
    }

    return results;
  }
  async convertToShares(amount: string) {
    const vault = await this.etherUtils.getContract(
      this.config.contracts.deploy.Vault,
      this.config.abis.IVault
    );
    const shares = await vault.convertToShares(amount);
    return shares;
  }
  async convertToAssets(amount: string) {
    const vault = await this.etherUtils.getContract(
      this.config.contracts.deploy.Vault,
      this.config.abis.IVault
    );
    const assets = await vault.convertToAssets(amount);
    return assets;
  }
  async approveMaxtoCCIP() {
    const maxUint256 = this.etherUtils.ethers.MaxUint256;
    const threshold = maxUint256 / 2n;
    const account = await this.etherUtils.getAccounts();
    const ccipBridgeAddress = this.config.contracts.deploy.CCIPBridge;

    // 获取合约实例
    const wstASTR = await this.etherUtils.getContract(
      this.config.contracts.WstASTR,
      this.config.abis.IERC20
    );
    const vault = await this.etherUtils.getContract(
      this.config.contracts.deploy.Vault,
      this.config.abis.IERC20
    );

    // 检查当前授权额度
    const wstASTRAllowance = await wstASTR.allowance(
      account,
      ccipBridgeAddress
    );
    const vaultAllowance = await vault.allowance(account, ccipBridgeAddress);

    const txs: any[] = [];

    // 如果WstASTR授权额度小于阈值，重新授权
    if (wstASTRAllowance < threshold) {
      const calldata = await this.etherUtils.encodeDataByABI({
        abi: this.config.abis.IERC20,
        functionName: "approve",
        executeArgs: [ccipBridgeAddress, maxUint256],
        target: this.config.contracts.WstASTR,
      });
      txs.push(await this.etherUtils.sendTransaction(calldata));
    }

    // 如果Vault授权额度小于阈值，重新授权
    if (vaultAllowance < threshold) {
      const calldata = await this.etherUtils.encodeDataByABI({
        abi: this.config.abis.IERC20,
        functionName: "approve",
        executeArgs: [ccipBridgeAddress, maxUint256],
        target: this.config.contracts.deploy.Vault,
      });
      txs.push(await this.etherUtils.sendTransaction(calldata));
    }
    return txs;
  }

  async approveMaxToVault() {
    const maxUint256 = this.etherUtils.ethers.MaxUint256;
    const threshold = maxUint256 / 2n;
    const account = await this.etherUtils.getAccounts();
    const vaultAddress = this.config.contracts.deploy.Vault;

    // 获取合约实例
    const wASTR = await this.etherUtils.getContract(
      this.config.contracts.WASTR,
      this.config.abis.IERC20
    );
    const wstASTR = await this.etherUtils.getContract(
      this.config.contracts.WstASTR,
      this.config.abis.IERC20
    );

    // 检查当前授权额度
    const wastrAllowance = await wASTR.allowance(account, vaultAddress);
    const wstASTRAllowance = await wstASTR.allowance(account, vaultAddress);

    const txs: any[] = [];

    // 如果WASTR授权额度小于阈值，重新授权
    if (wastrAllowance < threshold) {
      const calldata = await this.etherUtils.encodeDataByABI({
        abi: this.config.abis.IERC20,
        functionName: "approve",
        executeArgs: [vaultAddress, maxUint256],
        target: this.config.contracts.WASTR,
      });
      txs.push(await this.etherUtils.sendTransaction(calldata));
    }

    // 如果wstASTR授权额度小于阈值，重新授权
    if (wstASTRAllowance < threshold) {
      const calldata = await this.etherUtils.encodeDataByABI({
        abi: this.config.abis.IERC20,
        functionName: "approve",
        executeArgs: [vaultAddress, maxUint256],
        target: this.config.contracts.WstASTR,
      });
      txs.push(await this.etherUtils.sendTransaction(calldata));
    }
    return txs.length > 0 ? txs : true;
  }
  async getDepositASTRCallData(receiver: string, amount: string | bigint) {
    if (typeof amount === "bigint") {
      amount = amount.toString();
    }
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "depositASTR",
      executeArgs: [receiver],
      target: this.config.contracts.deploy.Vault,
      value: amount,
    });
    return calldata;
  }

  async depositASTR(receiver: string, amount: string | bigint) {
    const calldata = await this.getDepositASTRCallData(receiver, amount);
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }
  async depositWASTR(receiver: string, amount: string | bigint) {
    // console.log(this.config.abis.IVault);
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "depositWASTR",
      executeArgs: [receiver, amount],
      target: this.config.contracts.deploy.Vault,
    });
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }
  async getRequestUnstakeCallData(amount: string | bigint) {
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "requestUnstake",
      executeArgs: [amount],
      target: this.config.contracts.deploy.Vault,
    });
    return calldata;
  }

  async requestUnstake(amount: string | bigint) {
    // console.log(this.config.abis.IVault);
    const calldata = await this.getRequestUnstakeCallData(amount);
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }
  async withdrawWASTR(receiver: string, nonce: number) {
    // console.log(this.config.abis.IVault);
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "withdrawWASTR",
      executeArgs: [receiver, nonce],
      target: this.config.contracts.deploy.Vault,
    });
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }
  async withdrawASTR(receiver: string, nonce: number) {
    // console.log(this.config.abis.IVault);
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "withdrawASTR",
      executeArgs: [receiver, nonce],
      target: this.config.contracts.deploy.Vault,
    });
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }
  async withdrawASTRCCIP(receiver: string, nonce: number) {
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "withdrawASTRCCIP",
      executeArgs: [receiver, nonce],
      target: this.config.contracts.deploy.Vault,
    });
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }

  async getInstantWithdrawCallData(amount: string | bigint) {
    const calldata = await this.etherUtils.encodeDataByABI({
      abi: this.config.abis.IVault,
      functionName: "instantWithdraw",
      executeArgs: [amount],
      target: this.config.contracts.deploy.Vault,
    });
    return calldata;
  }
  async instantWithdraw(amount: string | bigint) {
    const calldata = await this.getInstantWithdrawCallData(amount);
    const tx = await this.etherUtils.sendTransaction(calldata);
    return tx;
  }
}
